import { css, useTheme } from 'styled-components';

const languageMap = {
  ARABIC: {
    direction: 'rtl',
    code: 'ar',
  },
  URDU: {
    direction: 'rtl',
    code: 'ur',
  },
  ENGLISH: {
    direction: 'ltr',
    code: 'en',
  },
};

export const getLangDirection = language => languageMap[language].direction;
export const getLangCode = language => languageMap[language].code;

export const useLanguage = useTheme;
export const rtl = (...styles) => props =>
  props.theme.dir === 'rtl' ? css(styles) : '';
